import * as React from 'react';
import { Helmet } from 'react-helmet';
import * as queryString from 'query-string';

import { isProdEnv } from 'ui-common/utils/globalWrappers';
import { QueryProps } from '../Login/LoginForm/loginFormUtils';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import * as featureFlags from 'login-utils/featureFlags';
import LeftPane, { LeftPaneProps } from '../Common/PaneLayout/LeftPane/LeftPane';

export default class LoginLeftPane extends React.Component<ReactRouter.RouteComponentProps<{}, {}>> {
  render() {
    const { location } = this.props;
    const leftPaneParams: LeftPaneProps = {
      appDocumentTitleProps: {
        title: 'Login',
      },
      title: 'Sign in to your account',
      subtitle: 'Welcome back! Sign in to view status or complete next steps on your loan.',
      showBackButton: false,
      loginButton: 'Sign up',
    };
    const queryParams = queryString.parse(location.search) as QueryProps;

    if (queryParams && queryParams.message === 'timedOut') {
      leftPaneParams.title = 'You’ve been signed out';
      const inactivityMessage = featureFlags.isEnabled('extendSessionToFour_20181016') ? '4 hours' : '30 minutes';
      leftPaneParams.subtitle = `For security, we sign you out of your account when you’re inactive for ${inactivityMessage}.`;
    }

    const { googleSearchVerificationKey } = deploymentConfig.get();

    return (
      <React.Fragment>
        {isProdEnv() &&
          googleSearchVerificationKey && (
            // adding this meta tag verifies our site ownership giving us access to Google Search data
            <Helmet>
              <meta name="google-site-verification" content={googleSearchVerificationKey} />
            </Helmet>
          )}
        <LeftPane {...this.props} {...leftPaneParams} />
      </React.Fragment>
    );
  }
}
